import {Record} from 'immutable';
import {schema} from 'normalizr';

const WorkflowStatus = Record({
    id: null,
    name: null,
    color: null,
    closed: false,
    openForEditor: false,
});

export const WorkflowStatusSchema = new schema.Entity('workflowStatuses');

export default WorkflowStatus;
